/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {detect} from '@webex/http-core';
import {getType} from 'mime';

/**
 * Determines the file type of the specified file
 * @param {FileLike} file
 * @param {Object} logger
 * @returns {Promise<string>}
 */
export default function detectFileType(file, logger) {
  if (file.type) {
    logger.info(`file already has type ${file.type}. using existing file.type.`);

    return Promise.resolve(file.type);
  }

  if (file.mimeType) {
    logger.info(`file already has mimeType ${file.type}. using existing file.mimeType.`);

    return Promise.resolve(file.mimeType);
  }

  // This kinda belongs in http core, but since we have no guarantee that
  // buffers are expected to have names there, it'll stay here for now.
  return detect(file).then((type) => {
    if (type === 'application/x-msi' || type === 'application/octet-stream') {
      logger.info(`detected filetype to be ${type}. Falling back to mime.lookup`);

      return getType(file.name);
    }

    logger.info(`detected filetype to be ${type}. returning it`);

    return type;
  });
}
